<div class="fc-page" *ngIf="community; else notFound">
  <button class="fc-back" (click)="back()">
    <i class="pi pi-arrow-left"></i> Todas as comunidades
  </button>

  <!-- Banner -->
  <div class="fc-banner" [style.background]="'linear-gradient(120deg, ' + community.color + '33, #1e1f23)'">
    <div class="fc-banner__strip" [style.background]="community.color"></div>
    <div class="fc-banner__content">
      <div class="fc-banner__icon" [style.background]="community.color">
        <i [class]="community.icon"></i>
      </div>
      <div class="fc-banner__info">
        <h1 class="fc-banner__name">{{ community.name }}</h1>
        <p class="fc-banner__desc">{{ community.description }}</p>
        <div class="fc-banner__meta">
          <span><i class="pi pi-users"></i> {{ short(community.members) }} membros</span>
          <span class="fc-online"><span class="fc-dot"></span> {{ community.online }} online</span>
        </div>
      </div>
      <button class="fc-join" [class.fc-join--in]="joined" (click)="joined = !joined">
        <i class="pi" [ngClass]="joined ? 'pi-check' : 'pi-plus'"></i>
        {{ joined ? 'Participando' : 'Participar' }}
      </button>
    </div>
  </div>

  <!-- Ordenação -->
  <div class="fc-sortbar">
    <button class="fc-sort" [class.fc-sort--active]="sort === 'hot'" (click)="setSort('hot')"><i class="pi pi-bolt"></i> Em alta</button>
    <button class="fc-sort" [class.fc-sort--active]="sort === 'new'" (click)="setSort('new')"><i class="pi pi-clock"></i> Recentes</button>
    <button class="fc-sort" [class.fc-sort--active]="sort === 'top'" (click)="setSort('top')"><i class="pi pi-chart-bar"></i> Top</button>
  </div>

  <!-- Posts -->
  <div class="fc-list">
    <app-forum-post-card *ngFor="let p of posts" [post]="p" [hideCommunity]="true"></app-forum-post-card>
    <div class="fc-empty-list" *ngIf="!posts.length">
      <i class="pi pi-inbox"></i>
      <p>Ainda não há posts nesta comunidade.</p>
    </div>
  </div>
</div>

<ng-template #notFound>
  <div class="fc-empty">
    <i class="pi pi-inbox"></i>
    <p>Comunidade não encontrada.</p>
    <button class="fc-back" (click)="back()"><i class="pi pi-arrow-left"></i> Voltar ao fórum</button>
  </div>
</ng-template>
